import styled from "styled-components";
export const ColDiv = styled.div`
width: ${props => props.width * 115}px;
`;
